/**
 * User-shell wrapper for the shared payment-methods screen.
 *
 * The top-level /payment-methods route is role-agnostic and is reached
 * from many places (banner taps, "Add or update payments" buttons, etc.).
 * This thin wrapper exists so the user nav bar can include a Payment tab
 * that lives under /user/payment — that way the tab highlight tracks
 * correctly when the user is on the screen.
 */
import PaymentMethodsScreen from '../payment-methods';

export default function UserPaymentScreen() {
  return <PaymentMethodsScreen />;
}
